
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import React, {useContext, useState} from 'react';
import confirmIcon from "../../../../../assets/confirm-orange.svg";
import SecurityService from "../../../../../services/security-service";
import { IdentityContext } from '../../../../../context/identity-context';
import {
  SECURITY_REJECT_ERROR,
  SECURITY_REJECT_SUCCESS
} from "../../../../../helpr/constants";
import SuccessModalContent
  from "../../../../securities/security-details/components/modal-content-success/modal-content-success";
import ErrorModalContent
  from "../../../../securities/security-details/components/modal-content-error/modal-content-error";
import styles from "./modal-content-reject-security.module.scss";

const RejectSecurityModalContent = ({data, updateTable, onClose, modalConfig}) => {
  const SUCCESS_TITLE = "SALES REPORT REJECTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const { setStyle } = modalConfig;
  const [ loading, setLoading ] = useState(false);
  const [ page, setPage ] = useState(0);
  const { user } = useContext(IdentityContext);
  const securityService = new SecurityService();
  const { securityId, username } = data;

  const rejectOrders = async () => {
    setLoading(true);
    try{
      const resp = await securityService.rejectOrders(
        securityId,
        user.attributes['custom:entity_id'],
        username
      );
      console.log(resp);
      updateTable(securityId, username);
      setPage(1);
    } catch(error){
      setStyle(styles['error-modal']);
      setPage(2);
    } finally {
      setLoading(false);
    }
  }

  const close = () => {
    setStyle(styles['confirm-modal']);
    onClose();
  }

  return  page === 0 ? (
    <div className={styles['reject-security']}>
      <Row>
        <Col lg={12}>
          <div>
            <h1>ARE YOU SURE YOU WANT TO REJECT THE SALESREPORT?</h1>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div>
            <img alt="Confirm" src={confirmIcon}/>
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <div className={styles['message']}>
            <p>Click Confirm to Reject.</p>
          </div>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button variant="warning" onClick={()=>rejectOrders()}>
              {loading? <Spinner size="sm" animation="border"/>: 'CONFIRM'}
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['cancel-button']}>
            <Button variant="secondary" onClick={()=>onClose()}>CANCEL</Button>
          </div>
        </Col>
      </Row>
    </div>
  ) : ( page === 1
    ? <SuccessModalContent title={SUCCESS_TITLE} message={SECURITY_REJECT_SUCCESS} onClose={close}/>
    : <ErrorModalContent title={ERROR_TITLE} message={SECURITY_REJECT_ERROR} onClose={close}/>)
}

export default RejectSecurityModalContent;

